module.exports = __webpack_public_path__ + "media/images/curve2-c634a6bc85127ae9563112e7ba9cd59a.png";